import React from 'react'
import TaskContent from '../components/tasks/TaskContent'

const AppsTasks = () => {
    return (
        <>
            <TaskContent/>
        </>
    )
}

export default AppsTasks